<div class="card">
  <div class="section-1">
    @if (question?.description) {
      <div class="question-1-title">
        {{ question?.description }}
      </div>
    }
    <mat-radio-group (change)="valueSelected($event)" aria-label="Select an option">
      <mat-radio-button value="1"></mat-radio-button>
      <mat-radio-button value="2"></mat-radio-button>
      <mat-radio-button value="3"></mat-radio-button>
      <mat-radio-button value="4"></mat-radio-button>
      <mat-radio-button value="5"></mat-radio-button>
    </mat-radio-group>
    <div class="label-section">
      <div class="poor-label">
        <div class="block-1">
          <h3>1</h3>
          <p>Very Poor</p>
        </div>
      </div>
      <div class="excellent-label">
        <div class="block-2">
          <h3>5</h3>
          <p>Excellent</p>
        </div>
      </div>
    </div>
  </div>
</div>
